import {QRCodeModel} from "./qr-code-model";
import {QRErrorCorrectLevel} from "./qr-constants";

interface Options {
    data: string,
    width: number,
    height: number,
    typeNumber: number,
    colorDark: string,
    colorLight: string,
    correctLevel: QRErrorCorrectLevel,
    useSVG: boolean;
}

export interface Drawing {
    // constructor(el: HTMLElement, options: Options): Drawing;
    draw(model: QRCodeModel): void;

    clear(): void;
}

export class DrawingSVG implements Drawing {
    constructor(private el: HTMLElement, private options: Options) {
        this.el = el;
        this.options = options;
    }

    draw(model: QRCodeModel) {
        const count = model.getModuleCount();
        this.clear();

        const children = [
            createElement('rect', {
                fill: this.options.colorLight,
                width: '100%',
                height: '100%',
            }),
            createElement('rect', {
                fill: this.options.colorDark,
                width: 1,
                height: 1,
                id: 'template',
            }),
        ];

        for (let row = 0; row < count; row++) {
            for (let col = 0; col < count; col++) {
                if (model.isDark(row, col)) {
                    children.push(createElement('use', {
                            href: '#template',
                            x: col,
                            y: row,
                        }
                    ));
                }
            }
        }

        this.el.appendChild(
            createElement('svg', {
                viewBox: `0 0 ${count} ${count}`,
                width: '100%',
                height: '100%',
                fill: this.options.colorLight,
            }, children)
        );
    }

    clear() {
        while (this.el.hasChildNodes()) {
            this.el.removeChild(this.el.lastChild);
        }
    }
}

export class DrawingTable implements Drawing {
    constructor(private el: HTMLElement, private options: Options) {
        this.el = el;
        this.options = options;
    }

    draw(model: QRCodeModel) {
        // const count = model.getModuleCount();
        // const width = Math.floor(this.options.width / count);
        // const height = Math.floor(this.options.height / count);
        // const html = ['<table style="border:0;border-collapse:collapse;">'];
        //
        // for (let row = 0; row < count; row++) {
        //     html.push('<tr>');
        //
        //     for (let col = 0; col < count; col++) {
        //         html.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + width + 'px;height:' + height + 'px;background-color:' + (model.isDark(row, col) ? this.options.colorDark : this.options.colorLight) + ';"></td>');
        //     }
        //
        //     html.push('</tr>');
        //     html.push('</table>');
        //     this.el.innerHTML = html.join('');
        //
        //     const elTable = this.el.childNodes[0];
        //     const nLeftMarginTable = (this.options.width - elTable.offsetWidth) / 2;
        //     const nTopMarginTable = (this.options.height - elTable.offsetHeight) / 2;
        //
        //     if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
        //         elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
        //     }
        // }
    }

    clear() {
        this.el.innerHTML = '';
    }
}

export class DrawingCanvas implements Drawing {
    canvas: HTMLCanvasElement;

    constructor(private el, private options: Options) {
        this.el = el;
        this.options = options;

        this.canvas = createElement('canvas', {
            width: options.width,
            height: options.height,
        })
    }

    draw(model: QRCodeModel) {
        const count = model.getModuleCount();
        const width = this.options.width / count;
        const height = this.options.height / count;
        const roundedWidth = Math.round(width);
        const roundedHeight = Math.round(height);
        const context = this.canvas.getContext('2d');

        for (let row = 0; row < count; row++) {
            for (let col = 0; col < count; col++) {
                const isDark = model.isDark(row, col);
                const left = col * width;
                const top = row * height;

                context.strokeStyle = isDark ?
                    this.options.colorDark :
                    this.options.colorLight;
                context.lineWidth = 1;
                context.fillStyle = isDark ?
                    this.options.colorDark :
                    this.options.colorLight;
                context.fillRect(left, top, width, height);
                context.strokeRect(
                    Math.floor(left) + 0.5,
                    Math.floor(top) + 0.5,
                    roundedWidth,
                    roundedHeight
                );
                context.strokeRect(
                    Math.ceil(left) - 0.5,
                    Math.ceil(top) - 0.5,
                    roundedWidth,
                    roundedHeight
                );
            }
        }

        this.el.appendChild(this.canvas);
    }

    clear(): void {
    }
}

function createElement<T extends HTMLElement>(tag: string, attrs: { [key: string]: string | number } = {}, children: HTMLElement | HTMLElement[] = []): T {
    const element = document.createElement(tag);

    Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value + ''));

    if (Array.isArray(children)) {
        children.forEach(item => element.appendChild(item))
    } else {
        element.appendChild(children);
    }

    return element as any;
}
